import { AchievementSnapshot } from '../types';
import {
  getAchievementDefinitions,
  getAchievementStatus,
} from '../utils/achievements';

interface Props {
  snapshot: AchievementSnapshot;
  onBack: () => void;
}

export function AchievementsPanel({ snapshot, onBack }: Props) {
  const definitions = getAchievementDefinitions();
  const grouped = definitions.reduce<Record<string, typeof definitions>>((acc, definition) => {
    const bucket = acc[definition.category] ?? [];
    bucket.push(definition);
    acc[definition.category] = bucket;
    return acc;
  }, {});

  return (
    <section>
      <div className="page-header">
        <div className="title-stack">
          <p className="eyebrow">Milestones</p>
          <h1>Achievements</h1>
          <p className="helper-text">Progress is stored locally and synced to your device.</p>
        </div>
        <button className="btn ghost" onClick={onBack} aria-label="Back to menu">
          Back
        </button>
      </div>
      <div className="achievement-groups">
        {Object.entries(grouped).map(([category, items]) => (
          <article key={category} className="menu-card full-span">
            <div className="menu-card-header">
              <div>
                <p className="eyebrow">{category}</p>
                <h2>{category} goals</h2>
              </div>
            </div>
            <div className="achievement-grid">
              {items.map((definition) => {
                const status = getAchievementStatus(definition, snapshot);
                const percent = definition.target
                  ? Math.min(100, Math.round((status.progress / definition.target) * 100))
                  : status.unlocked
                    ? 100
                    : 0;
                return (
                  <div
                    key={definition.id}
                    className={`achievement-card ${status.unlocked ? 'unlocked' : 'locked'}`}
                    data-testid={`achievement-${definition.id}`}
                  >
                    <div className="achievement-card-header">
                      {/* <div className="icon-circle" aria-hidden>
                        {definition.icon ?? '🏆'}
                      </div> */}
                      <div>
                        <p className="eyebrow">{category}</p>
                        <h3>{definition.name}</h3>
                      </div>
                      {/* <span className={`pill ${status.unlocked ? 'success' : 'muted'}`}>
                        {status.unlocked ? 'Unlocked' : 'Locked'}
                      </span> */}
                    </div>
                    <p className="helper-text">{definition.description}</p>
                    <div className="achievement-progress" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
                      <div className="achievement-progress-fill" style={{ width: `${percent}%` }} />
                    </div>
                    {definition.target ? (
                      <p className="helper-text">
                        {Math.min(status.progress, definition.target)} / {definition.target}
                      </p>
                    ) : null}
                    {status.unlockedAt ? (
                      <p className="helper-text">Unlocked on {new Date(status.unlockedAt).toLocaleDateString()}</p>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
